export default "__VITE_ASSET__45ad80fa__"